import { IVoc } from "@/domain/entities/bbs";
import { useBbsStore } from "@/stores/bbsStore";
import { ref } from "vue";
import { useOffsetPagination } from "../shared/useOffsetPagination";
import { CustomCodeGroup } from "@/types";

export const useGetVocList = () => {
  const bbsStore = useBbsStore();
  const {
    currentLimit,
    currentOffset,
    currentPage,
    totalCount,
    updateCurrentPage,
  } = useOffsetPagination();

  const vocList = ref<IVoc[]>([]);

  const isFetching = ref(false);

  const fetchVocList = async (
    searchKeyword: string,
    myPostOnly: boolean,
    shouldClear: boolean
  ) => {
    if (isFetching.value) return;

    isFetching.value = true;

    if (shouldClear) {
      updateCurrentPage(0);
    }

    const result = await bbsStore.getVocList(
      CustomCodeGroup.VOQ,
      searchKeyword,
      currentOffset.value,
      currentLimit,
      undefined,
      myPostOnly
    );

    isFetching.value = false;

    if (!result.data) return;

    if (shouldClear) {
      clearVocList();
    }

    vocList.value = [...vocList.value, ...result.data.list];
    totalCount.value = result.data.totalCount;
    updateCurrentPage(currentPage.value + 1);
  };

  const clearVocList = () => {
    vocList.value = [];
  };

  return {
    vocList,
    totalCount,
    fetchVocList,
    clearVocList,
  };
};
